import { IChoiceFilters } from '@/interfaces/choice.interfaces';
import { FilterBlockType } from '@/interfaces/constructor.interfaces';
import type { IFilterValues } from '@/interfaces/filters.interfaces';
import instanceOfFilterRange from '@/utils/instanceOfFilterRange';

type Params = {
  type: FilterBlockType;
  filterChoiceValue?: IChoiceFilters[string];
  filterValues?: IFilterValues;
};

type PrepareFilterItemValueFunction = {
  (params: Params): unknown;
};

/**
 * Получить значения для фильтра с учетом
 * типа фильтра
 */
const prepareFilterItemValue: PrepareFilterItemValueFunction = ({
  type,
  filterChoiceValue,
  filterValues,
}) => {
  switch (type) {
    case FilterBlockType.FilterSlider: {
      if (instanceOfFilterRange(filterValues)) {
        return filterChoiceValue ?? filterValues.value[1];
      }
      return filterChoiceValue;
    }
    case FilterBlockType.FilterRangeSlider: {
      if (instanceOfFilterRange(filterValues)) {
        return filterChoiceValue ?? filterValues.value;
      }
      return filterChoiceValue;
    }
    default:
      return filterChoiceValue;
  }
};

export default prepareFilterItemValue;
